<template>
  <v-sheet
    class="booking-resource"
    :class="classes"
    :color="color"
    v-bind="$attrs"
  >
    <h3 v-if="hasTitleSlot" class="booking-resource__title text-h6">
      <slot name="title" :item="resource" />
    </h3>

    <p class="booking-resource__item">
      <strong>{{ $t('BOOKING.RESOURCES.ITEM') }}: </strong>
      {{ resource.title || '' }}
    </p>
    <p class="booking-resource__item">
      <strong>{{ $t('BUILDING_COMPLEXES.ITEM') }}: </strong>
      {{ buildingComplex || '' }}
    </p>
    <p class="booking-resource__item">
      <strong>{{ $t('BUILDINGS.ITEM') }}: </strong>
      {{ building || '' }}
    </p>
    <p class="booking-resource__item">
      <strong>{{ $t('ITEM.TYPE') }}: </strong>
      {{ type || '' }}
    </p>
    <p class="booking-resource__item">
      <strong>{{ $t('BOOKING.CAPACITY.ITEM') }}: </strong>
      {{ capacity || '' }}
    </p>
    <p class="booking-resource__item">
      <span class="mr-4">
        <strong>{{ $t('BOOKING.RESOURCES.MIN') }}: </strong>
        {{ min || '' }}
      </span>

      <span>
        <strong>{{ $t('BOOKING.RESOURCES.MAX') }}: </strong>
        {{ max || '' }}
      </span>
    </p>
    <p class="booking-resource__item">
      <strong>{{ $t('BOOKING.RESOURCES.ACCESS_DAYS') }}: </strong>
      <weekdays
        class="transparent d-inline-block"
        style="height: 30px"
        :value="days"
        color="primary"
        readonly
      />
    </p>
    <p class="booking-resource__item">
      <span class="mr-4">
        <strong>{{ $t('ITEM.TIME_FROM') }}: </strong>
        {{ timeFrom || '' }}
      </span>

      <span>
        <strong>{{ $t('ITEM.TIME_TO') }}: </strong>
        {{ timeTo || '' }}
      </span>
    </p>
  </v-sheet>
</template>

<script>
import Weekdays from '@/modules/_global/_components/Weekdays';

export default {
  name: 'BookingResourceSheet',

  components: {
    Weekdays
  },

  props: {
    resource: {
      type: Object,
      default: () => ({
        time_from: '12:00',
        time_to: '16:00'
      })
    },
    color: {
      type: String,
      default: 'grey lighten-4'
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    hasTitleSlot() {
      return !!this.$slots['title'] || !!this.$scopedSlots['title'];
    },
    classes() {
      return {
        'booking-resource_small': this.small
      };
    },
    buildingComplex() {
      return (
        this.resource.building_complex && this.resource.building_complex.name
      );
    },
    building() {
      return this.resource.building && this.resource.building.street;
    },
    type() {
      return this.resource.type && this.resource.type.name;
    },
    days() {
      return this.resource.days || [];
    },
    min() {
      return this.resource.reserve_min;
    },
    max() {
      return this.resource.reserve_max;
    },
    timeFrom() {
      return this.resource.time_from;
    },
    timeTo() {
      return this.resource.time_to;
    },
    capacity() {
      return this.resource.capacity;
    }
  }
};
</script>

<style lang="scss">
.booking-resource {
  &__item,
  &__title {
    display: block;
    margin-bottom: 1rem;
  }

  &_small &__item,
  &_small &__title {
    display: block;
    margin-bottom: 0.4rem;
  }

  & &__item {
    font-size: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
